export default __webpack_public_path__ + "static/media/stockmarket.697f5900.jpeg";